<template>
    <div class="home">
        <h1>Welcome to Fenwick Lodge <sup>No.</sup>68</h1>
    </div>
</template>

<script>
    // @ is an alias to /src
    export default {
        name: 'home',
        components: {}
    }
</script>
